// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2DbJq","file":"styles_file__3F_HI"};